export default __webpack_public_path__ + "maps-examples-default-callout-thumbnail-480-edc743f28623a52ff6353e08cbfed9df.webp";